import { Component, inject, Input } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { RouterLink } from "@angular/router";
import { MarketRulesComponent } from "../../components/market-rules/market-rules.component";
import { MyMarketsService } from "../my-markets.service";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { AsyncPipe } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "app-my-markets-bf-header",
  imports: [MatExpansionModule, RouterLink, MatIconModule, AsyncPipe, MatTooltipModule],
  templateUrl: "./my-markets-bf-header.component.html",
  styleUrl: "./my-markets-bf-header.component.scss",
})
export class MyMarketsBfHeaderComponent {
  @Input() data: any;
  myMarketsService = inject(MyMarketsService);
  bottomSheet = inject(MatBottomSheet);

  removeFromMyMarkets(event: any) {
    event?.stopPropagation();
    this.myMarketsService.removeMarket(this.data?.marketId);
  }

  handleRules(data: any, event?: any) {
    event?.stopPropagation();
    this.bottomSheet.open(MarketRulesComponent, {
      data,
      panelClass: "rules-sheet",
    });
  }

  getMarketRoute(market: any) {
    return [
      "/app/main",
      {
        outlets: {
          navigation: ["event", market?.event?.id || market?.eventId],
          content: ["event-markets", market?.event?.id, "market", market?.marketId],
        },
      },
    ];
  }
}
